import { Component, Input } from '@angular/core';
import { Caption } from '@dashboard/models';

@Component({
  selector: 'sp-dashboard-banner',
  template: `
    <div class="dashboard-banner">
      <i class="fa-solid dashboard-banner-icon fa-2x" [ngClass]="bannerMessage.icon"></i>
      <h4>
        {{ bannerMessage.prefix }}! You are bringing home {{ bannerMessage.amount }} on
        {{ bannerMessage.date }}.
      </h4>
    </div>
  `,

  styleUrls: ['./dashboard-banner.component.scss'],
})
export class DashboardBannerComponent {
  @Input() bannerMessage: Caption;
}
